import type { AuthClient } from '@/contexts/auth';
import type { OverviewCageStatus } from '@/domain/client';

export const BREADCRUMB_SEPARATOR = '/';

export interface BreadcrumbLocation {
    id: number;
    name: string;
}

export interface BreadcrumbCage {
    id: number;
    name: string;
    /**
     * The pen's current cohort, when cohort data was requested at all.
     *
     * Both fields are absent with the feature flag off — the overview simply does
     * not carry `activeFishGroup` then — which is what keeps the dropdown and the
     * links it builds identical to before without a flag check of their own.
     */
    fishGroupId?: number;
    fishGroupName?: string;
    /** Smolt production tank. Its dashboard overview is read at the `all` daypart. */
    smolt?: boolean;
}

export type CagesByStatus = Record<OverviewCageStatus, BreadcrumbCage[]>;

export interface LocationsByStatus {
    active: BreadcrumbLocation[];
    inactive: BreadcrumbLocation[];
}

export interface ClientsByStatus {
    active: AuthClient[];
    inactive: AuthClient[];
}
